/* Slider
================================ */
function focusSlider(t){
	var s = t.parent().find('.slider-track');
	if(!s.hasClass('focus') && s.find('.thumb').length > 1){
		$('.focus').removeClass('focus')
		s.addClass('focus')
	}
}
function nextSlide(){
	var t = $('.slider-track.focus'),
		 target = t.find('.slide:first-child').next();
	t.prepend(target, target.nextAll())
	updateSliderCount(t)
}
function prevSlide(){
	var t = $('.slider-track.focus'),
		 target = t.find('.slide:last-child');
	t.prepend(target)
	updateSliderCount(t)
}
function updateSliderCount(t){
	t.parent().find('.slider-count_current').text(
		t.find('.slide:first-child').data('pos')
	);
}
$('.next').click(function(){
	clearAutoPlay()
	focusSlider($(this));
	nextSlide()
});
$('.prev').click(function(){
	clearAutoPlay()
	focusSlider($(this))
	prevSlide()
});

/* Autoplay sliders
================================ */
const $G = $('#product-gallery');
var totalSliders = $G.find('.slider').length;
$('.slider-track').each(function(){
	if($(this).find('.thumb').length == 1){
		totalSliders = totalSliders - 1;
	}
})
function clearAutoPlay(){
	if(autoPlay === true){
		autoPlay = false;
		clearInterval(autoSlide);
	}
}
function autoSlideGalleries(){
	var c = 0;
	$('.slider-track').each(function(){
		var t = $(this),
			 legnth = t.find('.thumb').length,
			 target = t.find('.slide:first-child').next();
		if(legnth < 2){
			c = c-1;
		}else{
			c = c+1;
			setTimeout(function(){
				if(autoPlay === true){
					t.prepend(target, target.nextAll())
					updateSliderCount(t)
				}
			}, speed*c)
		}
	})
}
if(totalSliders > 0 && window.innerWidth > 600){
	var autoPlay = true,
		 autoSlide,
		 delay = speedx2 + speed*totalSliders*2;
	setTimeout(function(){
		if(autoPlay === true){
			autoSlideGalleries()
			autoSlide = setInterval(function(){
				autoSlideGalleries()
			}, delay)
		}
	}, delay)
	$(window).blur(function(){
		if(autoPlay === true){
			clearInterval(autoSlide);
		}
	// }).focus(function(){
	// 	if(autoPlay === true){
	// 		autoSlide = setInterval(function(){
	// 			autoSlideGalleries()
	// 		}, delay)
	// 	}
	})
}

/* Lighbox
================================ */
const lightBox = $('#lightbox-wrapper');
function pauseVideos(){
	if($('.lightbox-track video:not(:first-child)').length){
		$('.lightbox-track video:not(:first-child)').each(function(){
			$(this)[0].pause();
		});
	}
}
function playVideos(t){
	pauseVideos()
	if(t.find('.thumb:first-child').is('video')){
		t.find('video:first-child')[0].play();
	}
}
function nextSlideLightbox(){
	var t = $('.lightbox-track');
	t.append(t.find('.thumb:first-child'));
	playVideos(t)
	updateSlides(t)
}
function prevSlideLightbox(){
	var t = $('.lightbox-track');
	t.prepend(t.find('.thumb:last-child'));
	playVideos(t)
	updateSlides(t)
}
function updateSlides(t){
	var slide = t.find('.thumb:first-child'),
		 pos = slide.data('pos'),
		 slider = slide.data('slider');
	if(!$('.slider[data-slider="'+slider+'"] .slider-track').hasClass('focus')){
		$('.slider-track').removeClass('focus');
		$('.slider[data-slider="'+slider+'"] .slider-track').addClass('focus');
	}
	var t = $('.slider-track.focus');
	t.prepend(
		t.find('.slide[data-pos="'+pos+'"]'),
		t.find('.slide[data-pos="'+pos+'"]').nextAll()
	)
	updateSliderCount(t)
}

//Lightbox
$('.slider-zoom').click(function(){
	var t = $(this),
		 n = t.closest('.slide').first(),
		 slider = n.data('slider'),
		 pos = n.data('pos');

	//Active slider
	focusSlider(t)

	//Clear autoplay
	clearAutoPlay()

	//Open Lightbox
	$B.addClass('popup-active lightbox-active');
	lightBox.show()

	//Set correct slide
	$('.lightbox-track').prepend(
		$('.lightbox-track .thumb[data-slider="'+slider+'"][data-pos="'+pos+'"]'),
		$('.lightbox-track .thumb[data-slider="'+slider+'"][data-pos="'+pos+'"]').nextAll()
	);
	var t = $('.lightbox-track');
	playVideos(t)

});

//Next Lightbox slide
$('#lightbox .prev').click(function(){
	prevSlideLightbox()
});
$('#lightbox .next').click(function(){
	nextSlideLightbox()
});

//Zoom in/out
$('#lightbox-wrapper .thumb').click(function(e){
	var t = $(this),
		 pos = e.clientY,
		 h = window.innerHeight/3;
	if(window.innerWidth > 600){
		lightBox.toggleClass('big');
		if(lightBox.hasClass('big') && pos > h){
			var top = t.height();
			if(pos < h*2){
				top = top/2 - $('#lightbox').height()/2
			}
			$('#lightbox').scrollTop(top);
		}
	}
});

/* Pop–ups
================================ */
function closePopUp(){
	var t = $('.popup:visible')
	$B.removeClass('popup-active');
	t.hide();
	if(t.is(lightBox)){
		$B.removeClass('lightbox-active');
		lightBox.removeClass('big')
	}
}
$('.popup-close').click(function(){
	closePopUp();
});

/* Size Chart
================================ */
const sizechart = $('#size-chart-wrapper');
$('#size-chart-trigger').click(function(){
	$B.addClass('popup-active');
	sizechart.show()
});

/* PDP
================================ */
$('#product-select').change(function(){
	var t = $(this),
		 val = t.find('option:selected').attr('data-price'),
		 txt;
	t.parent().addClass('selected').siblings('#add-to-cart').prop('disabled', false);
	if(val != undefined){
		if($('html').attr('currency') == 'USD'){
			fetch(`${api}`)
				.then((response) => response.json())
				.then((data) => {
					let x = data.rates['TWD'],
						 y = data.rates['USD'],
						 money = (y/x)*(val.split(',').join(''));
					txt = money.toLocaleString('en', {
						minimumFractionDigits: 0,
						maximumFractionDigits: 0,
					})
					val = txt;
					$('#product-price, #add-to-cart wrap span:last-child').html('<span class="money" val="'+val+'">'+val+'</span>');
				});
		}else{
			$('#product-price, #add-to-cart wrap span:last-child').html('<span class="money" val="'+val+'">'+val+'</span>');
		}
	}
});

/* Device detection
================================ */
if($B.hasClass('mobile')){
	
	//Slider
	$('.slider').bind('touchstart', function(event){
		tsX = event.changedTouches[0].screenX;
		focusSlider($(this).find('.slider-zoom'))
		clearAutoPlay()
	}).bind('touchend', function(event){
		teX = event.changedTouches[0].screenX;
		if(teX <= tsX && (tsX - teX > 50)){
			nextSlide()
		}
		if(teX >= tsX && (teX - tsX > 50)){
			prevSlide()
		}
	});

	//Lightbox
	lightBox.bind('touchstart', function(event){
		tsX = event.changedTouches[0].screenX;
	}).bind('touchend', function(event){
		teX = event.changedTouches[0].screenX;
		if(window.innerWidth > 600){
			if(teX <= tsX && (tsX - teX > 50)){
				nextSlideLightbox()
			}
			if(teX >= tsX && (teX - tsX > 50)){
				prevSlideLightbox()
			}
		}
	});

}else{
	
	//Keyboard functions
	$(document).keyup(function(e){
		var legnth = $('.slider-track.focus .thumb').length;
		if($B.hasClass('lightbox-active')){
			legnth = lightBox.find('.thumb').length
		}
		if(legnth > 1 && window.innerWidth > 600){
			if(e.keyCode == '37'){
				if($B.hasClass('lightbox-active') && !lightBox.hasClass('big')){
					prevSlideLightbox()
				}else if(!$B.hasClass('popup-active')){
					prevSlide()
				}
			}else if(e.keyCode == '39'){
				if($B.hasClass('lightbox-active') && !lightBox.hasClass('big')){
					nextSlideLightbox()
				}else if(!$B.hasClass('popup-active')){
					nextSlide()
				}
			}
		}
		if(e.key == 'Escape' && $B.hasClass('popup-active')){
			closePopUp();
		}
	});

}
